import { CAMPAIGN_PARAMS, MAX_UTM_PARAMS, MAX_VALUE_LENGTH, UTM_PREFIX } from '../constants';

const UTM_KEY_PATTERN = /^utm_[a-z0-9_]+$/;
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS = /[\u0000-\u001f\u007f]/g;

const sanitiseValue = value => {
  if (typeof value !== 'string') return null;
  const cleaned = value.replace(CONTROL_CHARS, '').trim().slice(0, MAX_VALUE_LENGTH);
  return cleaned || null;
};

const isAllowedKey = key => CAMPAIGN_PARAMS.includes(key) || UTM_KEY_PATTERN.test(key);

/**
 * Reduces raw key/value pairs to the allowlisted campaign set. Keys are
 * lowercased, values trimmed and capped, the first occurrence of a key wins and
 * at most MAX_UTM_PARAMS utm keys are kept. Returns null when nothing survives.
 */
export function sanitiseParams(entries = []) {
  let utmCount = 0;

  const params = entries.reduce((acc, [rawKey, rawValue]) => {
    const key = typeof rawKey === 'string' ? rawKey.trim().toLowerCase() : '';
    if (!isAllowedKey(key) || key in acc) return acc;

    const isUtm = key.startsWith(UTM_PREFIX);
    if (isUtm && utmCount >= MAX_UTM_PARAMS) return acc;

    const value = sanitiseValue(rawValue);
    if (!value) return acc;

    if (isUtm) utmCount += 1;
    acc[key] = value;
    return acc;
  }, {});

  return Object.keys(params).length ? params : null;
}

/**
 * Reads the campaign parameters from a query string ("?a=b" or "a=b").
 */
export function extractCampaignParams(search = '') {
  if (typeof search !== 'string' || !search) return null;
  return sanitiseParams(Array.from(new URLSearchParams(search).entries()));
}

/**
 * The query string of a Next.js asPath or url, without the hash.
 */
export function getSearchFromUrl(url = '') {
  if (typeof url !== 'string') return '';
  const [, search = ''] = url.split('#')[0].split('?');
  return search;
}
